import React, { useMemo } from "react";
import { Card, Avatar, Button, message } from "antd";
import { GiftOutlined } from "@ant-design/icons";
import moment from "moment";
import "./BirthdayWidget.css";

function getInitials(employeeStr) {
  if (!employeeStr) return "?";
  const parts = String(employeeStr).trim().split(/\s+/);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  return (parts[0] || "?")[0].toUpperCase();
}

function parseBirthdayDate(dateStr) {
  if (!dateStr) return null;
  const cleaned = String(dateStr).trim();
  const m = moment(cleaned, ["DD MMMM", "D MMMM", "DD MMM", "D MMM"], true);
  return m.isValid() ? m : null;
}

function isToday(dateObj) {
  if (!dateObj) return false;
  const today = moment();
  return dateObj.month() === today.month() && dateObj.date() === today.date();
}

function formatDisplayDate(dateObj) {
  if (!dateObj) return "";
  return dateObj.format("MMM DD");
}

export function BirthdayWidget({ birthdayData }) {
//   const rawList = Array.isArray(birthdayData)
//     ? birthdayData
//     : birthdayData?.data ?? [];
  const list = birthdayData;

  const { todayList, upcomingList } = useMemo(() => {
    const today = [];
    const upcoming = [];
    const now = moment().startOf("day");
    const currentYear = now.year();
    const windowEnd = now.clone().add(30, "days");
    list.forEach((item) => {
      const dateObj = parseBirthdayDate(item.date_of_birth);
      if (!dateObj) return;
      const withYear = dateObj.clone().year(currentYear).startOf("day");
      if (isToday(withYear)) {
        today.push({ ...item, _date: withYear });
      } else if (
        withYear.isAfter(now) &&
        withYear.isSameOrBefore(windowEnd)
      ) {
        // Next 30 days from today (tomorrow through today + 30) → Upcoming
        upcoming.push({ ...item, _date: withYear });
      }
      // Past birthdays (before today) are not shown
    });
    upcoming.sort((a, b) => a._date.valueOf() - b._date.valueOf());
    return { todayList: today, upcomingList: upcoming };
  }, [list]);

  const handleWish = (item) => {
    const name = (item.employee || "").replace(/^\d+\s*-\s*/, "").trim() || "them";
    message.success(`Birthday wish sent to ${name}! 🎉`);
  };

  const displayName = (item) => {
    const s = item.employee || "";
    return s.replace(/^\d+\s*-\s*/, "").trim() || s;
  };

  const designationLine = (item) => {
    const des = item.hidden_designation || "";
    const dept = item.hidden_hepartment || "";
    if (des && dept) return `${des} • ${dept}`;
    return des || dept || "";
  };

  return (
    <div className="birthday-widget">
      <div className="birthday-widget__card" bordered={false}>
        <div className="birthday-widget__header">
          <span className="birthday-widget__header-icon">🎂</span>
          <span className="birthday-widget__header-title">Today&apos;s Celebrations</span>
        </div>

        <div className="birthday-widget__body">
          {todayList.length > 0 && (
            <div className="birthday-widget__section">
              <div className="birthday-widget__today-list">
                {todayList.map((item, idx) => (
                  <div key={item.hidden_user_id || idx} className="birthday-widget__today-card">
                    <div className="birthday-widget__today-card-bg" />
                    <div className="birthday-widget__today-card-inner">
                      <div className="birthday-widget__avatar-wrap birthday-widget__avatar-wrap--today">
                        <Avatar
                          size={48}
                          className="birthday-widget__avatar birthday-widget__avatar--today"
                        >
                          {getInitials(item.employee)}
                        </Avatar>
                        <span className="birthday-widget__avatar-cake">🎂</span>
                      </div>
                      <div className="birthday-widget__today-info">
                        <p className="birthday-widget__name">{displayName(item)}</p>
                        <p className="birthday-widget__meta">{designationLine(item)}</p>
                      </div>
                      {/* <Button
                        type="primary"
                        size="small"
                        icon={<GiftOutlined />}
                        className="birthday-widget__wish-btn"
                        onClick={() => handleWish(item)}
                      >
                        Wish
                      </Button> */}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          <div className="birthday-widget__section">
            <div className="birthday-widget__section-title birthday-widget__section-title--muted">
              Upcoming
            </div>
            <div className="birthday-widget__upcoming-list">
              {upcomingList.length === 0 && todayList.length === 0 ? (
                <p className="birthday-widget__empty">No birthdays this month.</p>
              ) : (
                upcomingList.map((item, idx) => (
                  <div key={item.hidden_user_id || idx} className="birthday-widget__upcoming-row">
                    <Avatar
                      size={40}
                      className="birthday-widget__avatar birthday-widget__avatar--upcoming"
                    >
                      {getInitials(item.employee)}
                    </Avatar>
                    <div className="birthday-widget__upcoming-info">
                      <p className="birthday-widget__name birthday-widget__name--sm">
                        {displayName(item)}
                      </p>
                      <p className="birthday-widget__meta birthday-widget__meta--sm">
                        {item.hidden_designation || ""}
                      </p>
                    </div>
                    <span className="birthday-widget__date">
                      {formatDisplayDate(item._date)}
                    </span>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BirthdayWidget;
